//
// Mutable globals set by the app shell and read by low-level services (the httpService request headers).
// This module must stay dependency-free: importing anything from App/ here recreates the circular
// dependency through AppContext.ts (which constructs CurrentUser/GlobalDataCache at module scope) and
// crashes module initialization with "Cannot access 'X' before initialization".
//
export let globalOrgUnitId: string | undefined = undefined;
export let globalUserLang: string | undefined = undefined;
export let globalDefOrgLang: string | undefined = undefined;

export function setGlobalOrgUnitId(value: string | undefined) {
  globalOrgUnitId = value;
}

export function setGlobalUserLang(value: string | undefined) {
  globalUserLang = value;
}

export function setGlobalDefOrgLang(value: string | undefined) {
  globalDefOrgLang = value;
}
